webpackJsonp([108123921682220],{

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    min-width: 33.33%;\n    order: 2;\n  '], ['\n    min-width: 33.33%;\n    order: 2;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    min-width: 33.33%;\n    order: 1;\n    margin-right: 1em;\n    margin-left: 2em;\n    margin-right: 0;\n    margin-bottom: 2em;\n'], ['\n    min-width: 33.33%;\n    order: 1;\n    margin-right: 1em;\n    margin-left: 2em;\n    margin-right: 0;\n    margin-bottom: 2em;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _media = __webpack_require__(16);
	
	var _media2 = _interopRequireDefault(_media);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable no-undef, react/prop-types */
	
	
	var style = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-bottom:10%;margin-top:3.5rem;color:', _colors2.default.primary, ';& ul{list-style-type:none;color:', _colors2.default.primary, ';}h1,h2{margin-top:0;padding-bottom:0.5em;}p{margin-bottom:1em;}min-width:33.33%;order:1;', _media2.default.mid(_templateObject), ';');
	
	var linkStyle = /*#__PURE__*/(0, _reactEmotion.css)('color:', _colors2.default.primary, ';text-decoration:underline;&:hover{text-decoration:none;}');
	
	var flexStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin-top:3.5rem;height:100%;flex-wrap:nowrap;flex-direction:column;justify-content:space-around;', _media2.default.mid(_templateObject2), ';');
	
	var emptyColStyle = /*#__PURE__*/(0, _reactEmotion.css)('min-width:33.33%;order:3;min-height:2em;');
	
	var imgStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin-right:auto;margin-left:auto;box-sizing:content-box;max-width:70%;');
	
	var outerImgWrapper = /*#__PURE__*/(0, _reactEmotion.css)('width:8em;min-width:60%;align-self:flex-end;order:2;margin-left:auto;margin-right:auto;', _media2.default.mid(_templateObject3), ';');
	
	var fullHeight = /*#__PURE__*/(0, _reactEmotion.css)('min-height:100%;');
	
	var Liput = function Liput(_ref) {
	  var data = _ref.data;
	  var apteekkari = data.apteekkari;
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    { className: fullHeight },
	    _react2.default.createElement(
	      _Layout.Flex,
	      { className: flexStyle },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        className: imgStyle,
	        outerWrapperClassName: outerImgWrapper,
	        alt: 'Apteekkari, Kuvaaja: Inkeri J\xE4ntti',
	        sizes: apteekkari.childImageSharp.sizes,
	        imgStyle: {
	          objectFit: 'contain',
	          width: '100%',
	          height: 'auto',
	          boxSizing: 'content-box'
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: style, color: _colors2.default.secondary },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Liput'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Peruslippu 15 \u20AC'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'S-etukortilla* 13 \u20AC'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Alle 10-vuotiaat 10 \u20AC'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'small',
	            null,
	            '*S-etukortilla kahden euron alennus peruslipun hinnasta.',
	            _react2.default.createElement('br', null),
	            'S-etukortti on esitett\xE4v\xE4 sek\xE4 oston ett\xE4 sis\xE4\xE4np\xE4\xE4syn yhteydess\xE4.'
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Lipunmyynti'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Kulttuuritalo Valveen lippumyym\xE4l\xE4',
	          _react2.default.createElement('br', null),
	          'Hallituskatu 7, Oulu',
	          _react2.default.createElement('br', null),
	          'Avoinna ke\u2013su 12\u201319,',
	          _react2.default.createElement('br', null),
	          'puh. (08) 5584 7575',
	          _react2.default.createElement('br', null),
	          '(Ilman toimituskuluja)'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: linkStyle,
	            href: 'https://www.ticketmaster.fi/search/?keyword=owla+ja+kadonnut+walkia',
	            target: '_blank',
	            rel: 'noopener'
	          },
	          'Ticketmaster.fi'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Ticketmaster Suomen lippukaupat',
	          _react2.default.createElement('br', null),
	          '(Lippukaupat periv\xE4t omat toimituskulunsa noudon yhteydess\xE4.)'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Tiedustelut'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Tuottaja Hanna Poikela,',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:hanna.poikela@gmail.com' },
	            'hanna.poikela@gmail.com'
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: emptyColStyle })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Liput;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(4);
	
	var sizes = {
	  large: 1024,
	  mid: 832,
	  small: 640
	};
	
	// Iterate through the sizes and create a media template
	var media = Object.keys(sizes).reduce(function (acc, label) {
	  acc[label] = function () {
	    return (/*#__PURE__*/(0, _reactEmotion.css)('@media (min-width:', sizes[label] / 16, 'em){', /*#__PURE__*/_reactEmotion.css.apply(undefined, arguments), ';}')
	    );
	  };
	
	  return acc;
	}, {});
	
	exports.default = media;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-liput-js-42a9145526f25281e738.js